<template>
  <div class="zoox-component zoox-color-picker">
    <v-color-picker
      v-if="type === 'canvas' || type === 'full'"
      ref="canvas"
      hide-sliders
      :hide-inputs="!showInput"
      :canvas-height="canvasHeight"
      :value="value"
      @update:color="onUpdateColor"
      @input="onChange($event)"
    ></v-color-picker>

    <z-card v-if="type === 'palette' || type === 'full'" width="auto">
      <template #content>
        <z-scrollbar
          ref="palette"
          :style="`max-height: ${paletteHeight}px`"
          class="color-palette"
        >
          <template v-for="(color, index) of colors">
            <div
              :key="index"
              class="color-item"
              :class="{selected: value.toUpperCase() === color.toUpperCase()}"
              :style="{'background-color': color}"
              @click="onChange(color)"
            >
              <z-icon
                v-if="value.toUpperCase() === color.toUpperCase()"
                :color="iconColor"
                size="16"
                class="selected-icon"
              >
                $check_rounded
              </z-icon>
            </div>
          </template>
        </z-scrollbar>
      </template>
    </z-card>
  </div>
</template>

<script>
import invert from 'invert-color'
/**
 * @displayName Color Picker
 */
export default {
  name: 'ZColorPicker',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Valor do modelo. Deve ser uma cor em hexadecimal
     *
     * @modelName value
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * Tipo do color picker que deve ser utilizado
     * @values palette, canvas, full
     */
    type: {
      type: String,
      default: 'palette',
    },
    /**
     * Altura da paleta de cores
     */
    paletteHeight: {
      type: Number,
      default: 150,
    },
    /**
     * Altura do canvas
     */
    canvasHeight: {
      type: Number,
      default: 150,
    },
    /**
     * Mostra inputs de cor
     */
    showInput: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      iconColor: '',
    }
  },
  computed: {
    colors() {
      const allColors = Object.keys(this.$zoox.colors).map(
        (key) => this.$zoox.colors[key]
      )
      const colors = []

      for (let color of allColors) {
        if (!colors.some((c) => color === c)) {
          colors.push(color)
        }
      }

      return colors
    },
  },
  methods: {
    onChange(color) {
      /**
       * Emitido quando uma cor é clicada ou selecionada
       *
       * @property {string} color - Cor selecionada
       */
      this.$emit('change', color)

      //normaliza a cor para hexadecimal e inverte a cor para aplicar ao ícone de checked
      let last2Chars = color.slice(-2).toUpperCase()
      let correctHexColor =
        color.length > 4 && last2Chars === 'FF' ? color.slice(0, -2) : color

      this.iconColor = invert(correctHexColor, true)
    },

    onUpdateColor({hex}) {
      this.iconColor = invert(hex, true)
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-color-picker {
  display: grid;
  row-gap: 10px;

  .color-palette {
    display: grid;
    width: 100%;
    gap: 4px;
    justify-content: center;
    grid-template-columns: repeat(auto-fit, 20px);

    .color-item {
      position: relative;
      display: flex;
      align-items: center;
      padding: 5px;
      justify-content: center;
      cursor: pointer;
      height: 20px;
      border-radius: 50%;
      width: 100%;
      transition: transform 0.2s ease-in-out;

      &.selected {
        border: 2px solid black;
      }

      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>
